import { SHOW_ANALYSIS } from 'constants/actionTypes';

const initialState = true;

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ANALYSIS:
      return action.bool || initialState;
    default:
      return state;
  }
};
